/**
 * Configuração de Tarifas e Taxas Bancárias — Ajustes Globais
 * (prototype: erpone_configura_o_de_tarifas_e_taxas_banc_rias)
 *
 * Contrato: GET /finance/bank-tariffs?channel=GENERAL → PaginatedResponseDto<BankTariffResponseDto>
 */
import { BankTariffsChannelPage } from './BankTariffsChannelPage';

export function BankTariffsPage(): JSX.Element {
  return (
    <BankTariffsChannelPage
      channel="GENERAL"
      title="Configuração de Tarifas e Taxas Bancárias"
      subtitle="Ajustes globais de tarifas por serviço/evento."
    />
  );
}